import { render, staticRenderFns } from "./ProjectBatchInfoView.vue?vue&type=template&id=2e9410da&scoped=true"
import script from "./ProjectBatchInfoView.vue?vue&type=script&lang=js"
export * from "./ProjectBatchInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9410da",
  null
  
)

export default component.exports